/**
 * Decodes HTML entities (like &hellip; or &amp;) into their visual characters.
 */
export const decodeHTMLEntities = (text) => {
    if (!text) return '';
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
};
